import { createAction, props } from '@ngrx/store';
import { Bookpage } from '@pcp/core/interfaces';
import { DrawingToolConfig, DrawingToolName, StrokeColor, StrokeWidth, ToolbarPosition } from "shared/classroom/toolbar/core";

export const enableDrawingTools = createAction(
    '[Toolbar] Enable Drawing tools'
);

export const disableDrawingTools = createAction(
    '[Toolbar] Disable Drawing tools',
    props<{ data: any }>()
);

export const updateConfig = createAction(
    '[Toolbar] Update toolbar and drawing tool config',
    props<{ config: DrawingToolConfig }>()
);

// Toolbar

export const toggleDrawingTool = createAction(
    '[Toolbar] Toggle (enable/disable) a drawing tool',
    props<{ toolName: DrawingToolName }>()
);

export const deactivateAllTools = createAction(
    '[Toolbar] Deactivate all activated tools'
);

export const toggleBookpageTool = createAction(
    '[Toolbar] Toggle (enable/disable) the bookpage tool'
);

export const showBookpageListDialog = createAction(
    '[Toolbar] Show a dialog/list of boopages for the current slide'
);

export const closeBookpageListDialog = createAction(
    '[Toolbar] Hide the bookpage list dialog'
);

export const bookpageHasBeenSelected = createAction(
    '[Preview Screen] Bookpage has been selected',
    props<{ bookpage: Bookpage }>()
);

export const activateDrawingTool = createAction(
    '[Toolbar] Activate a drawing tool',
     props<{ toolName: DrawingToolName }>()
);

/**
 * Bookpage selection dialog was closed.
 * The user has selected a bookpage which should now be shown inside the preview screen.
 */
export const closeBookpageDialogConfirm = createAction(
    '[Toolbar] Bookpage dialog confirmed',
    props<{ selectedBookpage: Bookpage }>()
);

/**
 * Bookpage selection dialog was closed.
 * The user has _not_ selected a bookpage.
 */
export const closeBookpageDialogCancel = createAction(
    '[Toolbar] Bookpage dialog selection canceled'
);

/**
 * Enables the bookpage tool.
 * As a result, a dialog should be opened in order to select a (single) bookpage.
 */
export const enableBookpageTool = createAction(
    '[Toolbar] Enable bookpage tool'
);

/**
 * Turn on the color palete tool.
 * As a result, a dialog should be opened in order to select a (single) color.
 */
export const toggleColorPalette = createAction(
    '[Toolbar] Toggle (enable/disable) color palette tool'
);

export const toggleDrawingMenu = createAction(
    '[Toolbar] Toggle (enable/disable) drawing menu'
);

export const openDrawingMenu = createAction(
    '[Toolbar] Open drawing menu'
);

export const closeDrawingMenu = createAction(
    '[Toolbar] Close drawing menu'
);

export const openFloatingToolbar = createAction(
    '[Toolbar] Open floating toolbar'
);

export const closeFloatingToolbar = createAction(
    '[Toolbar] Close floating toolbar'
);

/**
 * On a color selection from color palete tool.
 */
export const strokeColorSelected = createAction(
    '[Toolbar] Select stroke color',
    props<{ strokeColor: StrokeColor }>()
);

/**
 * Seeds the stroke color from `SLIDE_SYNC_TOOLBAR_CONFIG.colorDefault` when nothing is
 * stored yet. NOT a user action: kept separate from `strokeColorSelected` so it stays out
 * of the analytics log and out of the localStorage persist effect.
 */
export const strokeColorInitialized = createAction(
    '[Toolbar] Initialize stroke color',
    props<{ strokeColor: StrokeColor }>()
);

/**
 * On a strokeWidth selection from color palete tool.
 */
export const strokeWidthSelected = createAction(
    '[Toolbar] Select stroke width',
    props<{ strokeWidth: StrokeWidth }>()
);

/**
 * Disable the bookpage tool.
 * As a result, a dialog should be opened in order to select a (single) bookpage.
 */
export const disableBookpageTool = createAction(
    '[Toolbar] Disable bookpage tool'
);

export const toolbarUndo = createAction('[Toolbar] undo button clicked');

export const toolbarRedo = createAction('[Toolbar] redo button clicked');

export const toolbarNavigateToParent = createAction(
    '[Toolbar] navigate to parent lection/chapter button clicked'
);

export const setToolbarPosition = createAction(
    '[Toolbar] set toolbar position',
    props<{position: ToolbarPosition}>()
);

export const setSubmenuToolbarPosition = createAction(
    '[Toolbar] set toolbar submenu position',
    props<{position: 'left'| 'right'}>()
);
